import { useState, useCallback } from 'react';
import { generateIntroduction, type IntroGeneratorInput } from '@/services/ai';

interface UseIntroGeneratorReturn {
  introduction: string;
  isLoading: boolean;
  error: string | null;
  generate: (input: IntroGeneratorInput) => Promise<void>;
  reset: () => void;
}

export function useIntroGenerator(): UseIntroGeneratorReturn {
  const [introduction, setIntroduction] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generate = useCallback(async (input: IntroGeneratorInput) => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await generateIntroduction(input);
      setIntroduction(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'エラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setIntroduction('');
    setError(null);
  }, []);

  return { introduction, isLoading, error, generate, reset };
}
